<div class="container">
  <div [ngClass]="isDialog ? 'content-container-background' : ''" class="content-container">
    <div class="members-header-shell">
      <div class="members-header-actions">
        <button type="button" class="members-role-guide-button" data-tutorial-target="gadget-users-role-help" (click)="openRoleHelp()"
          (touchend)="$event.preventDefault(); $event.stopPropagation(); openRoleHelp();">
          <span class="members-role-guide-badge">?</span>
          <span>{{ 'Role guide' | translate }}</span>
        </button>
        <button *ngIf="!tutorialService.isGadgetUsersTutorialActive" type="button" class="members-tutorial-button" (click)="startGadgetUsersTutorial()">{{ 'Start Tutorial' | translate }}</button>
      </div>

      <p class="subheader-text members-header-text">{{ 'Members' | translate }}</p>
    </div>

    <!-- Only show content when both inputs are available -->
    <div *ngIf="gadgetComplete && labComplete" class="lab-users-container">

      <div class="row header-row">
        <span class="header-label">{{ 'User' | translate }}</span>
        <div class="role-container">
          <span class="header-label">{{ 'Role' | translate }}</span>
        </div>
      </div>

      <ng-container *ngFor="let gadgetUserComplete of clonedGadgetUsersComplete; let i = index">
        <div *ngIf="gadgetUserComplete.gadgetUser.active == true" class="row">
          <!--User Name-->
          <mat-form-field class="contact-info-input" appearance="fill">
            <input [disabled]="true" [(ngModel)]="gadgetUserComplete.userSafe.nickname" maxlength="320"
              (touchend)="$event.stopPropagation()" matInput>
          </mat-form-field>

          <!--Role-->
          <div class="role-container">
            <!-- If Lab Admin or Owner OR Legacy Gadget Admin: Role is Inherited and Fixed -->
            <div
              *ngIf="(gadgetUserComplete.labUserComplete && gadgetUserComplete.labUserComplete.labUser.roleId <= RoleEnum.ADMIN) || gadgetUserComplete.gadgetUser.roleId <= RoleEnum.ADMIN"
              class="inherited-role-label">
              {{ getRoleName(gadgetUserComplete.labUserComplete && gadgetUserComplete.labUserComplete.labUser.roleId <=
                RoleEnum.ADMIN ? gadgetUserComplete.labUserComplete.labUser.roleId :
                gadgetUserComplete.gadgetUser.roleId) }} <span class="inherited-tag"
                *ngIf="gadgetUserComplete.labUserComplete && gadgetUserComplete.labUserComplete.labUser.roleId <= RoleEnum.ADMIN">
                {{ '(Inherited)' | translate }}</span>
            </div>

            <!-- If Lab Viewer AND Gadget Role > Admin: Selectable Gadget Role (Creator or Viewer) -->
            <mat-form-field
              *ngIf="(!gadgetUserComplete.labUserComplete || gadgetUserComplete.labUserComplete.labUser.roleId > RoleEnum.ADMIN) && gadgetUserComplete.gadgetUser.roleId > RoleEnum.ADMIN"
              appearance="fill">
              <mat-select
                [disabled]="!gadgetComplete.currentGadgetUserComplete || !gadgetService.canUserEditOtherGadgetUser(labComplete.currentLabUserComplete.labUser, gadgetUserComplete.labUserComplete?.labUser, gadgetComplete.currentGadgetUserComplete.gadgetUser, gadgetUserComplete.gadgetUser, false, false)"
                (touchend)="$event.stopPropagation()" [(ngModel)]="gadgetUserComplete.gadgetUser.newRoleId"
                (selectionChange)="onRoleChange(gadgetUserComplete)">
                <mat-option [value]="RoleEnum.CREATOR">{{ 'Creator' | translate }}</mat-option>
                <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>


        </div>

      </ng-container>

      <button
        *ngIf="gadgetComplete?.currentGadgetUserComplete && gadgetComplete.currentGadgetUserComplete.gadgetUser.roleId <= RoleEnum.ADMIN"
        (click)="updateGadgetUserSettings()"
        (touchend)="$event.preventDefault();$event.stopPropagation();updateGadgetUserSettings();"
        class="component-content login-button welcome-input primary-lighter-background" mat-raised-button>{{ 'Update Gadget Users' | translate }}</button>

    </div>
  </div>

</div>
